<template>
  <div class="d-search">
    <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.6-3.6" />
    </svg>
    <a-input
      v-model="inputValue"
      :placeholder="placeholder || $t('search')"
      @change="handleSearch"
      :allowClear="true"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    searchVal: {
      type: String,
      required: true
    },
    clear: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default() {
        return '';
      }
    }
  },
  watch: {
    searchVal(newValue) {
      this.inputValue = newValue;
    }
  },
  data() {
    return {
      inputValue: this.searchVal
    }
  },
  methods: {
    handleSearch: debounce(function () {
      this.$emit('onsearch', this.inputValue)
    }, 500),
    clearValue() {
      this.inputValue = '';
      this.clear();
    }
  }
}
</script>
